export default __webpack_public_path__ + "static/media/m-logo-black.49986933.svg";